<template>
  <div class="min-h-screen flex flex-col">
    <nav></nav>
    <main class="flex-1">
      <router-view />
    </main>
    <global-footer v-if="showGlobalFooter" />
  </div>
</template>

<script>
import GlobalFooter from "@/components/layout/GlobalFooter.vue";

export function shouldShowGlobalFooter(path = "") {
  return !(
    path === "/" ||
    path.startsWith("/auth") ||
    path.startsWith("/admin") ||
    path.startsWith("/store") ||
    path.startsWith("/insights") ||
    path.startsWith("/report-templates")
  );
}

export default {
  components: {
    GlobalFooter,
  },
  computed: {
    showGlobalFooter() {
      return shouldShowGlobalFooter(this.$route?.path || "");
    },
  },
  mounted() {
    document.title = "HovaStore";
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/main.scss";
</style>
